import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portal-status',
  templateUrl: './portal-status.component.html',
  styleUrls: ['./portal-status.component.scss']
})
export class PortalStatusComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
